import styled from 'styled-components';

import { media } from '../../../styles/constants';

const PhonesContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  position: relative;
  margin-top: 2.5rem;
  justify-content: center;

  img {
    width: 100%;
    height: auto;
  }

  > div {
    width: 100%;

    &:first-child {
      order: 2;
      min-width: 42rem;
      max-width: 56rem;
      margin-left: -2rem;
    }

    &:last-child {
      order: 1;
      min-width: 46rem;
      max-width: 65rem;
      margin-bottom: 2rem;
    }
  }

  @media (min-width: ${media.tabletPortrait}) {
    margin-top: 4rem;
  }

  @media (min-width: ${media.tabletLandscape}) {
    margin-top: 4rem;
    justify-content: initial;

    > div:first-child {
      max-width: 80rem;
      width: 51%;
      padding-left: 7rem;
    }

    > div:last-child {
      position: absolute;
      max-width: 80rem;
      width: 60%;
      left: auto;
      bottom: auto;
      right: -8rem;
      top: -25rem;
    }
  }

  @media (min-width: ${media.desktop}) {
    margin-top: 1rem;

    > div:first-child {
      width: 55%;
      padding-left: 8rem;
      padding-top: 4rem;
    }

    > div:last-child {
      width: 66%;
      right: -25rem;
      top: -15rem;
    }
  }

  @media (min-width: ${media.bigDesktop}) {
    margin-top: 5rem;

    > div:first-child {
      width: 70%;
      padding-top: 7rem;
    }

    > div:last-child {
      width: 79%;
      right: -42rem;
    }
  }
`;

export default PhonesContainer;
